import Vue from "vue";
import App from "./App.vue";
import VueCookie from "vue-cookie";
import router from "@/router";
import store from "@/store";
import "@/assets/scss/index.scss";
import ElementUI from "element-ui";
import { Message, MessageBox } from "element-ui";
import VueClipboard from "vue-clipboard2";
import dict from "@/common/dict";
import * as types from "@/common/vuex.const";
import * as routerConst from "@/common/router.const";
import * as commonConst from "@/common/common.const";
import cloneDeep from "lodash/cloneDeep";
import "element-ui/lib/theme-chalk/index.css";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueCookie);
Vue.use(VueClipboard);

Vue.prototype.$u = {
  constant: commonConst,
  message: Message,
  confirm: MessageBox.confirm,
  store: store,
  routerConst: routerConst,
  vuexConst: types,
  dict: dict
};

// 保存整站vuex本地储存初始状态
window.SITE_CONFIG = {};
window.SITE_CONFIG[types.STORE_STATE] = cloneDeep(store.state);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
